var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.baseClass},[(_vm.label)?_c('EpbText',{class:[`${_vm.baseClass}__text`, `${_vm.baseClass}__text--label`],attrs:{"type":"overline","color":_vm.ColorEnum.NEUTRAL_75}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]):_vm._e(),_c('span',{staticClass:"scroll--y"},_vm._l((_vm.options),function(option){return _c(_vm.isMultiple ? 'UiCheckbox' : 'UiRadio',_vm._b({key:option.value,tag:"component",class:`${_vm.baseClass}__input`,on:{"input":function($event){_vm.$emit(
          'input',
          _vm.isMultiple
            ? $event
              ? _vm.ArrayUtils.addUniqueItems(_vm.value, [option.value])
              : _vm.value.filter(val => val !== option.value)
            : option.value,
        )}}},'component',
        _vm.isMultiple
          ? {
              value: _vm.value.includes(option.value),
              boxPosition: 'right',
            }
          : {
              name: `${option.value}`,
              value: _vm.value,
              trueValue: option.value,
              buttonPosition: 'right',
            }
      ,false),[_c('EpbText',{class:[`${_vm.baseClass}__text`, `${_vm.baseClass}__text--option`],attrs:{"tag":"p"}},[(option.tooltip)?_c('EpbBadge',{staticClass:"eicon",attrs:{"tooltip":option.tooltip,"size":"mini","color":_vm.ColorEnum.NEUTRAL_25}},[_vm._v("\n          info\n        ")]):_vm._e(),_vm._v("\n        "+_vm._s(option.label ?? option.value)+"\n      ")],1)],1)}),1),_c('EpbButton',{class:`${_vm.baseClass}__button`,on:{"click":function($event){return _vm.$emit('action')}}},[_vm._v("\n    "+_vm._s(_vm.action)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }